import { render } from "./survey_add.vue?vue&type=template&id=b1d1abc6&scoped=true"
import script from "./survey_add.vue?vue&type=script&lang=js"
export * from "./survey_add.vue?vue&type=script&lang=js"

import "./survey_add.vue?vue&type=style&index=0&id=b1d1abc6&scoped=true&lang=scss"
import "./survey_add.vue?vue&type=style&index=1&id=b1d1abc6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1d1abc6"]])

export default __exports__